import React from 'react';

export default class Timer extends React.Component {
	static propTypes = {
	};

	constructor(props) {
		super(props);
		this.state = {
			days: '',
			hours: '',
			minutes: '',
			seconds: '',
		}
		
	}

	componentWillMount(){
		setInterval(this.setInterval, 1);
		// this.setInterval();
	}

	setInterval = data => {
		let date1 = new Date(this.props.startDate);
		let date2 = new Date();

		let delta = Math.abs(date1 - date2) / 1000;

		let days = Math.floor(delta / 86400);
		delta -= days * 86400;

		let hours = Math.floor(delta / 3600) % 24;
		delta -= hours * 3600;

		let minutes = Math.floor(delta / 60) % 60;
		delta -= minutes * 60;

		let seconds = Math.floor(delta % 60);

		this.setState({
			days: days +' days ',
			hours: hours +' hours ',
			minutes: minutes +' minutes ',
			seconds: seconds +' seconds ',
		});
	}

	render() {
		return (
			<React.Fragment><b>{this.state.days} {this.state.hours} {this.state.minutes} {this.state.seconds} Left</b></React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/Timer.js